/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import SpainLogo from '../../static/images/flags/spain.png'
import KingdomLogo from '../../static/images/flags/kingdom.png'
import withLocale, { ComponentProps } from '../../providers/Locale/withLocale'
import { Request } from 'fetchboi'

interface Props extends ComponentProps {
  embed?: boolean;
  responsive? : boolean;
}

const LanguageSelector = ({ responsive, embed, locale }: Props) => {
  if (!locale) {
    return null
  }

  const setLanguage = (language: string) => {
    locale.setLanguage(language)

    Request.getCustomHeader = () => ({
      'Content-Language': language,
    })
  }

  return (
    <Container responsive={responsive} embed={embed}>
      {/* <Button selected={locale.currentLanguage === 'es'} onClick={() => setLanguage('es')}  embed={embed}>
        <Flag src={SpainLogo}/>
        <p>Esp</p>
      </Button> */}

      {/* <Button selected={locale.currentLanguage === 'en'} onClick={() => setLanguage('en')}  embed={embed}>
        <Flag src={KingdomLogo}/>
        <p>Ing</p>
      </Button> */}
    </Container>
  )
}

const Container = styled.div<any>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;

  ${({ responsive, embed }) => (responsive || embed) && `
    width: 100%;
    justify-content: center;
    position: relative
    margin-bottom: 20px;
    margin-top: 30px;
    background-color: #FFF;
    transform: translateY(100%);
  `}
  
  ${({ embed }) => embed && `
    display: flex !important;
  `}

  ${({ responsive }) => responsive && `
    @media screen and (min-width: 901px) {
      display: none;
    }
  `}
  
  ${({ responsive }) => !responsive && `
    @media screen and (max-width: 900px) {
      display: none;
    }
  `}
  }
`

const Flag = styled.img<any>`
  width: 39px;
  height: 24px;
  object-fit: cover;
`

const Button = styled.button<any>`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  margin: 0 10px;
  border-radius: 3px;
  overflow: hidden;
  box-shadow: 0 4px 10px 0 rgba(71, 94, 123, 0.1);
  transform: none;
  transition: all .5s cubic-bezier(0.19, 1, 0.22, 1);
  outline: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #FFF;

  &:hover {
    box-shadow: 0 10px 10px 0 rgba(71, 94, 123, 0.15);
    transform: scale(1.05) translateY(-2px);
  }

  ${({ selected }) => selected && `
    font-weight: 600;
    background-color: #fbfbfb;
    transform: scale(1.07) translateY(-1px) !important;
    box-shadow: 0 7px 10px 0 rgba(71, 94, 123, 0.12);
  `}

  p {
    margin: 0;
    padding: 2px 0;
  }
  
  @media screen and (max-width: 900px) {
    flex-direction: row;

    p {
      padding: 0 10px;
    }
  }
  
  ${({embed}) => embed && `
    flex-direction: row !important;
    
    p {
      padding: 0 10px;
    }
  `}
`

export default withLocale(LanguageSelector)
